import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getTemplates } from '../utils/urls';

import { TemplateResult } from '../types/procedureBuilder';
import { ErrorModal } from 'types/modalTypes';

async function fetchExistingTemplates({
  showPanel,
  accountId,
  templateType,
}: TVariables): Promise<TResult> {
  if (!showPanel)
    return new Promise((resolve, reject) => {
      reject();
    });
  const response = await fetch(getTemplates(accountId, templateType), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Array<TemplateResult> | undefined;
  StatusCode: number;
  IsSuccess: boolean;
};

type TVariables = {
  showPanel: boolean;
  accountId: number;
  templateType: string;
};

function useGetExistingTemplates({
  showPanel,
  accountId,
  templateType,
}: TVariables): UseQueryResult<TResult, TError> {
  return useQuery(
    ['getExistingTemplates', showPanel, accountId, templateType],
    async () => {
      return await fetchExistingTemplates({
        showPanel,
        accountId,
        templateType,
      });
    },
    {
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetExistingTemplates };
